<div class="d-flex justify-content-center text-center">
  <div class="spinner-border m-5" role="status">
    <div class="sr-only"></div>
  </div>
</div>
